import { TextComponentConfig } from '../text/text-component-config.interface';

export interface CompareTableLabel {
  fieldName: string;
  text: TextComponentConfig;
  index: number;
}
